import { Component, Directive, Input, ContentChildren, OnInit, OnDestroy, forwardRef, Inject,
         QueryList, SecurityContext, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { SafeResourceUrl, SafeStyle, DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { MdSidenavToggleResult } from '@angular/material';

import { TdLayoutComponent } from '../layout.component';

import { TdCollapseAnimation } from '../../common/animations/collapse/collapse.animation';
export class TdNavigationDrawerMenuDirective {

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[td-navigation-drawer-menu]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdNavigationDrawerMenuDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdNavigationDrawerMenuDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdNavigationDrawerMenuDirective.ctorParameters;
}

export class TdNavigationDrawerComponent implements OnInit, OnDestroy {
private _closeSubscription: Subscription;
private _menuToggled: boolean = false;
private _backgroundImage: SafeStyle;
/**
 * @return {?}
 */
get menuToggled(): boolean {
    return this._menuToggled;
  }

   _drawerMenu: QueryList<TdNavigationDrawerMenuDirective>;
/**
 * Checks if there is a [TdNavigationDrawerMenuDirective] as content.
 * @return {?}
 */
get isMenuAvailable(): boolean {
    return this._drawerMenu.length > 0;
  }
/**
 * Checks if there is a background image for the toolbar.
 * @return {?}
 */
get isBackgroundAvailable(): boolean {
    return !!this._backgroundImage;
  }
/**
 * sidenavTitle?: string
 * Title set in sideNav.
 */
sidenavTitle: string;
/**
 * icon?: string
 * 
 * icon name to be displayed before the title
 */
icon: string;
/**
 * logo?: string
 * 
 * logo icon name to be displayed before the title.
 * If [icon] is set, then this will not be shown.
 */
logo: string;
/**
 * color?: string
 * 
 * toolbar color option: primary | accent | warn.
 * If [color] is not set, default is used.
 */
color: string;
/**
 * navigationRoute?: string
 * 
 * option to set the combined route for the icon, logo, and sidenavTitle.
 */
navigationRoute: string;
/**
 * @param {?} backgroundUrl
 * @return {?}
 */
set backgroundUrl(backgroundUrl: any) {
    if (backgroundUrl) {
      let /** @type {?} */ sanitizedUrl: string = this._sanitize.sanitize(SecurityContext.RESOURCE_URL, backgroundUrl);
      this._backgroundImage = this._sanitize.sanitize(SecurityContext.STYLE, 'url(' + sanitizedUrl + ')');
    }
  }
/**
 * @return {?}
 */
get backgroundImage(): SafeStyle {
    return this._backgroundImage;
  }
/**
 * name?: string
 * 
 * string to be displayed as part of the navigation drawer sublabel.
 * if [email] is not set, then [name] will be the toggle menu text.
 */
name: string;
/**
 * email?: string
 * 
 * string to be displayed as part of the navigation drawer sublabel in the [toggle] menu text.
 * if [email] and [name] are not set, then the toggle menu is not rendered.
 */
email: string;
/**
 * Checks if router was injected.
 * @return {?}
 */
get routerEnabled(): boolean {
    return !!this._router && !!this.navigationRoute;
  }
/**
 * @param {?} _layout
 * @param {?} _router
 * @param {?} _sanitize
 */
constructor(
private _layout: TdLayoutComponent,
private _router: Router,
private _sanitize: DomSanitizer) {}
/**
 * @return {?}
 */
ngOnInit(): void {
    this._closeSubscription = this._layout.sidenav.onClose.subscribe(() => {
      this._menuToggled = false;
    });
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    if (this._closeSubscription) {
      this._closeSubscription.unsubscribe();
      this._closeSubscription = undefined;
    }
  }
/**
 * @return {?}
 */
toggleMenu(): void {
    if (this.isMenuAvailable) {
      this._menuToggled = !this._menuToggled;
    }
  }
/**
 * @return {?}
 */
handleNavigationClick(): void {
    if (this.routerEnabled) {
      this._router.navigateByUrl(this.navigationRoute);
      this.close();
    }
  }
/**
 * Proxy toggle method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public toggle(): Promise<MdSidenavToggleResult> {
    return this._layout.toggle();
  }
/**
 * Proxy open method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public open(): Promise<MdSidenavToggleResult> {
    return this._layout.open();
  }
/**
 * Proxy close method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public close(): Promise<MdSidenavToggleResult> {
    return this._layout.close();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-navigation-drawer',
  styleUrls: ['./navigation-drawer.component.css' ],
  templateUrl: './navigation-drawer.component.html',
  animations: [ TdCollapseAnimation() ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TdLayoutComponent, decorators: [{ type: Inject, args: [forwardRef(() => TdLayoutComponent), ] }, ]},
{type: Router, decorators: [{ type: Optional }, ]},
{type: DomSanitizer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_drawerMenu': [{ type: ContentChildren, args: [TdNavigationDrawerMenuDirective, ] },],
'sidenavTitle': [{ type: Input, args: ['sidenavTitle', ] },],
'icon': [{ type: Input, args: ['icon', ] },],
'logo': [{ type: Input, args: ['logo', ] },],
'color': [{ type: Input, args: ['color', ] },],
'navigationRoute': [{ type: Input, args: ['navigationRoute', ] },],
'backgroundUrl': [{ type: Input, args: ['backgroundUrl', ] },],
'name': [{ type: Input, args: ['name', ] },],
'email': [{ type: Input, args: ['email', ] },],
};
}

function TdNavigationDrawerComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdNavigationDrawerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdNavigationDrawerComponent.ctorParameters;
/** @type {?} */
TdNavigationDrawerComponent.propDecorators;
/** @type {?} */
TdNavigationDrawerComponent.prototype._closeSubscription;
/** @type {?} */
TdNavigationDrawerComponent.prototype._menuToggled;
/** @type {?} */
TdNavigationDrawerComponent.prototype._backgroundImage;
/** @type {?} */
TdNavigationDrawerComponent.prototype._drawerMenu;
/**
 * sidenavTitle?: string
 * Title set in sideNav.
 * @type {?}
 */
TdNavigationDrawerComponent.prototype.sidenavTitle;
/**
 * icon?: string
 * 
 * icon name to be displayed before the title
 * @type {?}
 */
TdNavigationDrawerComponent.prototype.icon;
/**
 * logo?: string
 * 
 * logo icon name to be displayed before the title.
 * If [icon] is set, then this will not be shown.
 * @type {?}
 */
TdNavigationDrawerComponent.prototype.logo;
/**
 * color?: string
 * 
 * toolbar color option: primary | accent | warn.
 * If [color] is not set, default is used.
 * @type {?}
 */
TdNavigationDrawerComponent.prototype.color;
/**
 * navigationRoute?: string
 * 
 * option to set the combined route for the icon, logo, and sidenavTitle.
 * @type {?}
 */
TdNavigationDrawerComponent.prototype.navigationRoute;
/**
 * name?: string
 * 
 * string to be displayed as part of the navigation drawer sublabel.
 * if [email] is not set, then [name] will be the toggle menu text.
 * @type {?}
 */
TdNavigationDrawerComponent.prototype.name;
/**
 * email?: string
 * 
 * string to be displayed as part of the navigation drawer sublabel in the [toggle] menu text.
 * if [email] and [name] are not set, then the toggle menu is not rendered.
 * @type {?}
 */
TdNavigationDrawerComponent.prototype.email;
/** @type {?} */
TdNavigationDrawerComponent.prototype._layout;
/** @type {?} */
TdNavigationDrawerComponent.prototype._router;
/** @type {?} */
TdNavigationDrawerComponent.prototype._sanitize;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
